export const BuildInfo = {timestamp:1782321874000}
